<template>
  <div
    class="map-icon"
    :style="wrapperStyle"
    v-html="iconHtml"
  />
</template>

<script>
export default {
  name: 'MapIcon',
  computed: {
    iconDefinition() {
      return {
        type: this.type,
        color: this.color,
        color_selected: this.color_selected,
        text_color: this.text_color,
        text_color_selected: this.text_color_selected,
        icon: this.icon,
        frame: this.frame,
      };
    },
    metrics() {
      return this.getMapObjectIconMetrics(this.type);
    },
    iconHtml() {
      return this.createMapObjectIconHtml(
        this.iconDefinition,
        {
          ...this.metrics,
          size: this.size,
          totalSize: this.size + (this.metrics.padding * 2),
        },
        this.count,
        this.label,
      );
    },
    wrapperStyle() {
      const totalSize = this.size + (this.metrics.padding * 2);
      return {
        display: 'inline-block',
        width: `${totalSize}px`,
        height: `${totalSize}px`,
      };
    },
  },
  props: {
    type: {
      type: String,
      default: 'circle',
    },
    color: {
      type: String,
      default: 'blue',
    },
    color_selected: {
      type: String,
      default: 'red',
    },
    text_color: {
      type: String,
      default: 'white',
    },
    text_color_selected: {
      type: String,
      default: 'green',
    },
    icon: {
      type: String,
      default: '0_label',
    },
    frame: {
      type: String,
      default: 'square_rounded',
    },
    size: {
      type: Number,
      default: 40,
    },
    count: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '0',
    },
  },
};
</script>

<style scoped>
.map-icon {
  line-height: 0;
}
</style>
